const rest = {
    server: process.env.REACT_APP_REST_SERVER,
    linkAndroid: process.env.REACT_APP_LINK_ANDROID,
    linkIos: process.env.REACT_APP_LINK_IOS,
}

export default rest;
